(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.dades.controller:DadesCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.submain.dades')
    .controller('RolsMainDadesCtrl', RolsMainDadesCtrl);

  function RolsMainDadesCtrl(rolData,$window, $rootScope,$stateParams,$state) {
    var vm = this;
    vm.ctrlName = 'RolsMainDadesCtrl';
    vm.rol=rolData.data;

    //functions
    vm.changeToForm = changeToForm;
    vm.deleteElem = deleteElem;
    vm.issuperadmin=  $rootScope.issuperadmin;


    function deleteElem() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('rols.main.delete', vm.rol);
    }

    function changeToForm() {
      $window.scrollTo(0, 0);
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $rootScope.$broadcast('rols.main.edit', vm.rol);
    }
   

   if (angular.isUndefined($stateParams.idRol) || $stateParams.idRol === null || !$stateParams.idRol) {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
      $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
    }
    else {
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': true});
    }
  }
}());
